import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { graphql } from 'react-apollo';
import { find, isEmpty } from 'lodash';
import CourseResource from '../_shared/CourseResource';
import SubunitSummary from './SubunitSummary';

import { getCourseOutline } from '../../queries';

import './UnitsList.scss';
import './Unit.scss';
import './UnitPreview/UnitPreview.scss';
import './SubunitDetail.scss';

const UnitsList = (props) => {
  const {
    data,
    subject,
    userData: { isStudent },
  } = props;

  if (!data || !data.courseOutline) {
    return null;
  }

  const { courseOutline } = data;

  /**
   * Prepare units list
   * */
  const { units: courseUnits, subunitLabel } = courseOutline;

  let units = [];
  (courseUnits || []).forEach((unit) => {
    /**
     * Ignore milestone units
     * @note milestone units have empty number
     * */
    if (unit.number) {
      units.push({
        ...unit,
        /**
         * Allow only teacher module draw
         * */
        teacherModule:
          find(unit.resources, { __typename: 'TeacherModuleResource' }) || {},
        subunitLabel,
      });
    }
  });

  const teacherModuleIntro =
    'Help students with additional instructional resources and a Practice FRQ for this unit';

  return (
    <div className="assignment-units-list units-list">
      {units.map((unit) => {
        const {
          id,
          title,
          displayName,
          number: unitNumber,
          teacherModule,
          subunits = [],
        } = unit;
        let teacherModuleLabel;
        let teacherModuleResource;
        if (!isStudent) {
          if (isEmpty(teacherModule)) {
            teacherModuleLabel = teacherModuleIntro;
          } else {
            teacherModuleLabel = 'Teacher Module';
            teacherModuleResource = (
              <CourseResource resource={teacherModule} subject={subject} />
            );
          }
        }

        return (
          <div className="unit-item" key={unitNumber}>
            <div className="unit-item-container">
              <div className="unit-item-title">
                <label>
                  {displayName}: {title}
                </label>
              </div>
              <div className="resource-teacher-module">
                {!isStudent && (
                  <Fragment>
                    <label>{teacherModuleLabel}</label>
                    {teacherModuleResource}
                  </Fragment>
                )}
              </div>
              <div className="subunits" key={id}>
                {(subunits || []).map((subunit) => {
                  const { resources = [], number: subunitNumber } = subunit;
                  return (
                    <div
                      className="subunit-detail"
                      key={`${unitNumber}-${subunitNumber}`}
                    >
                      <SubunitSummary
                        isLinkable={isStudent}
                        subject={subject}
                        unit={unit}
                        subunit={subunit}
                      />

                      <div className="subunit-resources">
                        <ul>
                          {!isStudent &&
                            (resources || []).map((resource) => {
                              /**
                               * Suppress the assessment resources
                               * */
                              if (
                                resource.__typename !== 'AssessmentResource'
                              ) {
                                return (
                                  <li key={resource.id}>
                                    <CourseResource
                                      resource={resource}
                                      subject={subject}
                                      unitNumber={unitNumber}
                                      subunitNumber={subunitNumber}
                                    />
                                  </li>
                                );
                              }
                            })}
                        </ul>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

UnitsList.displayName = 'UnitsList';

UnitsList.propTypes = {
  subject: PropTypes.string,
  subunitIds: PropTypes.array.isRequired,
  userData: PropTypes.object.isRequired,
};

const queryOptions = (props) => {
  const { subunitIds, subject, unitsClient } = props;

  return {
    client: unitsClient,
    variables: {
      subjectId: subject,
      filter: JSON.stringify({ tags: subunitIds }),
    },
  };
};

function mapStateToProps(state) {
  return {
    userData: state.userData,
  };
}
export default connect(mapStateToProps)(
  graphql(getCourseOutline, {
    options: queryOptions,
  })(UnitsList),
);
